import AutomaticRepliesViewState from 'mini-options-store/lib/store/schema/AutomaticRepliesViewState';
import changeIsLoading from '../../actions/changeIsLoading';
import clearIsDirty from '../../actions/clearIsDirty';
import ExternalAudience from 'owa-service/lib/contract/ExternalAudience';
import MailboxAutoReplyConfigurationOptions from 'owa-service/lib/contract/MailboxAutoReplyConfigurationOptions';
import OofState from 'owa-service/lib/contract/OofState';
import saveAutomaticRepliesOption from '../../actions/automaticReplies/saveAutomaticRepliesOption';
import saveMailboxAutomaticRepliesConfiguration from '../../services/saveMailboxAutomaticRepliesConfiguration';
import { getOptionsStore } from '../../store/Store';
import { orchestrator } from 'satcheljs';

const saveAutomaticRepliesOptionOrchestrator = orchestrator(
    saveAutomaticRepliesOption,
    async actionMessage => {
        // Loading is not needed if we are doing it async
        // start loading
        changeIsLoading(true);
        const store = getOptionsStore();
        if (store && store.activeViewState) {
            const viewState = store.activeViewState as AutomaticRepliesViewState;
            const automaticRepliesStatus = viewState.isAutomaticRepliesEnabled;
            const externalAudience = viewState.isReplyToEveryone
                ? ExternalAudience.All
                : ExternalAudience.None;

            let externalMessage = viewState.replyToExternalSendersText;
            if (
                viewState.isReplyToEveryone &&
                !viewState.isDifferentReplyForOrgAndExternalSenders
            ) {
                externalMessage = viewState.replyOnlyToMyOrganizationText;
            }

            // Build the contract object
            let mailboxAutoReplyConfigurationOptions: MailboxAutoReplyConfigurationOptions = null;
            if (!automaticRepliesStatus) {
                mailboxAutoReplyConfigurationOptions = {
                    AutoReplyState: OofState.Disabled,
                    ExternalAudience: externalAudience,
                };
            } else {
                // The new line is trimmed out in server, so replace it with <br />.
                const newLineRegex = /(?:\r\n|\r|\n)/g;
                const replaceNewLine = '<br />';
                mailboxAutoReplyConfigurationOptions = {
                    AutoReplyState: OofState.Enabled,
                    ExternalAudience: externalAudience,
                    ExternalMessage: externalMessage.replace(newLineRegex, replaceNewLine),
                    InternalMessage: viewState.replyOnlyToMyOrganizationText.replace(
                        newLineRegex,
                        replaceNewLine
                    ),
                };
            }

            // save the changes
            await saveMailboxAutomaticRepliesConfiguration(
                mailboxAutoReplyConfigurationOptions
            ).then(() => {
                clearIsDirty();
                // TODO: show toast of success or failure with retry.
            });
        }

        // remove loading
        changeIsLoading(false);
    }
);

export default saveAutomaticRepliesOptionOrchestrator;
